import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, unref as _unref, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = { key: 1 };
const _hoisted_2 = { key: 1 };
import { RouterLink } from "vue-router";
import Button from "primevue/button";
import SplitButton from "primevue/splitbutton";
import UIcon from "@/components/uikit/uComponents/UIcon.vue";
import { computed, ref } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'UButton',
    props: {
        icon: {
            type: String,
            default: ""
        },
        iconAfter: {
            type: String,
            default: ""
        },
        width: {
            type: String,
            default: "auto"
        },
        height: {
            type: String,
            default: "44px"
        },
        disabled: {
            type: Boolean,
            default: false
        },
        rounded: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        severity: {
            type: String,
            default: ""
        },
        type: {
            type: String,
            default: "button"
        },
        split: {
            type: Boolean,
            default: false
        },
        items: {
            type: Array,
            default: () => []
        },
        path: {
            type: String,
            default: ""
        }
    },
    emits: ["click"],
    setup(__props) {
        const props = __props;
        const PrimeButton = props.split ? SplitButton : Button;
        const isLink = props.severity == "menu";
        const text = ref(false);
        const outlined = ref(false);
        const fluid = ref(false);
        const center = ref(true);
        const currentSeverity = ref(props.severity);
        if (props.severity == "menu") {
            text.value = true;
            outlined.value = true;
            fluid.value = true;
            center.value = false;
            currentSeverity.value = "";
        }
        const cssVars = computed(() => {
            const style = {
                width: fluid.value ? "" : props.width,
                "--splitbutton-width": fluid.value ? "" : props.width,
                height: props.height,
                "justify-content": center.value ? "center" : "start",
                "--inner-justify-content": center.value ? "center" : "start",
                "font-size": "14px",
                "background-color": "auto",
                "border-color": "auto",
                "--img-position": "auto",
                "--p-button-border-radius": "8px",
                "--p-button-padding-x": "20px",
                "--p-button-padding-y": "0px",
                "--p-button-text-primary-color": "white"
            };
            if (props.split) {
                style.width = "auto";
            }
            if (props.type == "icon") {
                style["--img-position"] = "absolute";
                style.width = style.height;
            }
            if (props.severity == "transparent") {
                style["background-color"] = "transparent";
                style["border-color"] = "transparent";
            }
            return style;
        });
        const cssVarsLink = computed(() => {
            return {
                width: "100%"
            };
        });
        const buttonProps = computed(() => ({
            severity: currentSeverity.value,
            "button-severity": props.severity,
            type: props.type,
            disabled: props.disabled || props.loading,
            loading: props.loading,
            outlined: outlined.value,
            text: text.value,
            rounded: props.rounded,
            style: cssVars.value,
            fluid: fluid.value,
            model: props.items
        }));
        return (_ctx, _cache) => {
            return isLink
                ? (_openBlock(), _createBlock(_unref(RouterLink), {
                    key: 0,
                    style: _normalizeStyle(cssVarsLink.value),
                    to: { path: __props.path }
                }, {
                    default: _withCtx(() => [
                        _createVNode(_unref(PrimeButton), _mergeProps(buttonProps.value, {
                            onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('click', $event)))
                        }), {
                            default: _withCtx(() => [
                                (__props.icon && !__props.loading)
                                    ? (_openBlock(), _createBlock(UIcon, {
                                        key: 0,
                                        icon: __props.icon
                                    }, null, 8, ["icon"]))
                                    : _createCommentVNode("", true),
                                (_ctx.$slots['default'] && !__props.loading)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                        _renderSlot(_ctx.$slots, "default")
                                    ]))
                                    : _createCommentVNode("", true),
                                (__props.iconAfter && !__props.loading)
                                    ? (_openBlock(), _createBlock(UIcon, {
                                        key: 2,
                                        icon: __props.iconAfter
                                    }, null, 8, ["icon"]))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 3
                        }, 16)
                    ]),
                    _: 3
                }, 8, ["style", "to"]))
                : (_openBlock(), _createBlock(_unref(PrimeButton), _mergeProps({ key: 1 }, buttonProps.value, {
                    onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('click', $event)))
                }), {
                    default: _withCtx(() => [
                        (__props.icon && !__props.loading)
                            ? (_openBlock(), _createBlock(UIcon, {
                                key: 0,
                                icon: __props.icon
                            }, null, 8, ["icon"]))
                            : _createCommentVNode("", true),
                        (_ctx.$slots['default'] && !__props.loading)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _renderSlot(_ctx.$slots, "default")
                            ]))
                            : _createCommentVNode("", true),
                        (__props.iconAfter && !__props.loading)
                            ? (_openBlock(), _createBlock(UIcon, {
                                key: 2,
                                icon: __props.iconAfter
                            }, null, 8, ["icon"]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 3
                }, 16));
        };
    }
});
